import { render } from "./saved-cards.vue?vue&type=template&id=2f2bf73e"
import script from "./saved-cards.vue?vue&type=script&lang=ts"
export * from "./saved-cards.vue?vue&type=script&lang=ts"
script.render = render

export default script